import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface SkillsEditorProps {
  skills: string[];
  onChange: (skills: string[]) => void;
  label?: string;
  placeholder?: string;
  addButtonText?: string;
}

export const SkillsEditor = ({ skills, onChange, label = "Skills", placeholder = "Add a skill", addButtonText = "Add" }: SkillsEditorProps) => {
  const [skillsInput, setSkillsInput] = useState("");

  const handleAddSkill = () => {
    if (!skillsInput.trim()) return;
    onChange([...skills, skillsInput.trim()]);
    setSkillsInput("");
  };

  const handleRemoveSkill = (skillToRemove: string) => {
    onChange(skills.filter(skill => skill !== skillToRemove));
  };

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className="flex gap-2">
        <Input 
          value={skillsInput}
          onChange={(e) => setSkillsInput(e.target.value)}
          placeholder={placeholder}
          className="bg-gray-50 border-0 focus:ring-0"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddSkill();
            }
          }}
        />
        <Button 
          type="button" 
          onClick={handleAddSkill}
          variant="outline"
        >
          {addButtonText}
        </Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        {skills?.map((skill) => (
          <div key={skill} className="bg-gray-100 border border-gray-300 text-blue-500 px-3 py-1 rounded-sm flex items-center gap-1">
            {skill}
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700"
              onClick={() => handleRemoveSkill(skill)}
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
